import { ValidationError } from '../../shared/errors/BaseErrors';

export type DiscoveredChannelStatus = 'new' | 'verified' | 'unavailable' | 'not_a_channel' | 'rejected' | 'imported';

export type DiscoveredChannelKind = 'broadcast' | 'megagroup' | 'unknown' | '';

export type DiscoveredChannelSort = 'members' | 'mentions' | 'last_seen';

export const DISCOVERED_CHANNEL_STATUSES: DiscoveredChannelStatus[] = ['new', 'verified', 'unavailable', 'not_a_channel', 'rejected', 'imported'];

export const MAX_DISCOVERED_CHANNELS_PER_IMPORT = 500;

export interface DiscoveredChannelEntity {
  id: number;
  link: string;
  status: DiscoveredChannelStatus;
  kind: DiscoveredChannelKind;
  title: string;
  membersCount: number;
  isPrivate: boolean;
  mentionsCount: number;
  firstSeenAt: string;
  lastSeenAt: string;
  firstSourceMessageLink: string;
  verifiedAt?: string;
  verifyError: string;
  inCatalog: boolean;
}

export interface DiscoveredChannelFilters {
  statuses: DiscoveredChannelStatus[];
  kinds: DiscoveredChannelKind[];
  minMembers?: number;
  search: string;
  inCatalog?: boolean;
  sort: DiscoveredChannelSort;
}

export const DEFAULT_DISCOVERED_CHANNEL_FILTERS: DiscoveredChannelFilters = {
  statuses: ['verified'],
  kinds: [],
  search: '',
  inCatalog: false,
  sort: 'members',
};

export const canImportDiscoveredChannel = (channel: DiscoveredChannelEntity): boolean => channel.status === 'verified';

export const canRejectDiscoveredChannel = (channel: DiscoveredChannelEntity): boolean =>
  channel.status !== 'imported' && channel.status !== 'rejected';

export const selectionForImport = (channels: DiscoveredChannelEntity[]): number[] => {
  if (channels.length === 0) throw new ValidationError('discovered-channels-not-selected');
  if (channels.length > MAX_DISCOVERED_CHANNELS_PER_IMPORT) throw new ValidationError('discovered-channels-too-many');
  if (!channels.every(canImportDiscoveredChannel)) throw new ValidationError('discovered-channel-not-verified');
  return channels.map((channel) => channel.id);
};

export const selectionForReject = (channels: DiscoveredChannelEntity[]): number[] => {
  const ids = channels.filter(canRejectDiscoveredChannel).map((channel) => channel.id);
  if (ids.length === 0) throw new ValidationError('discovered-channels-not-selected');
  return ids;
};
